export default {"src":"/_next/static/media/404.3e6fe58e.svg","height":600,"width":600,"blurWidth":0,"blurHeight":0};